import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { CodeBlock } from "./CodeBlock";

function extractText(node) {
  if (node == null) return "";
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map(extractText).join("");
  if (node.props?.children != null) return extractText(node.props.children);
  return "";
}

/* Renders Markdown for Sara's replies. Fenced code blocks are handled by the
   dark editor CodeBlock (with copy button + syntax highlighting). */
export function Markdown({ children, className = "" }) {
  return (
    <div className={`sara-md text-[13px] leading-relaxed text-[#eaf4ff] ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          pre({ children }) {
            const child = Array.isArray(children) ? children[0] : children;
            const cls = child?.props?.className || "";
            const match = /language-([\w-]+)/.exec(cls);
            const code = extractText(child).replace(/\n$/, "");
            return <CodeBlock code={code} language={match ? match[1] : "text"} />;
          },
          code({ children, ...props }) {
            return (
              <code
                className="rounded bg-white/10 px-1.5 py-0.5 font-mono text-[12px] text-cyan-200"
                {...props}
              >
                {children}
              </code>
            );
          },
          a: (props) => (
            <a {...props} target="_blank" rel="noreferrer" className="text-cyan-300 underline underline-offset-2" />
          ),
          ul: (props) => <ul {...props} className="my-2 list-disc space-y-1 pl-5" />,
          ol: (props) => <ol {...props} className="my-2 list-decimal space-y-1 pl-5" />,
          li: (props) => <li {...props} className="marker:text-cyan-400/70" />,
          h1: (props) => <h1 {...props} className="mt-3 mb-2 text-lg font-bold text-white" />,
          h2: (props) => <h2 {...props} className="mt-3 mb-2 text-base font-bold text-white" />,
          h3: (props) => <h3 {...props} className="mt-2 mb-1 font-semibold text-white" />,
          p: (props) => <p {...props} className="my-1.5" />,
          strong: (props) => <strong {...props} className="font-semibold text-white" />,
          blockquote: (props) => (
            <blockquote {...props} className="my-2 border-l-2 border-cyan-400/40 pl-3 italic text-slate-300" />
          ),
          hr: () => <hr className="my-3 border-white/10" />,
          table: (props) => (
            <div className="my-2 overflow-x-auto">
              <table {...props} className="w-full border-collapse text-[12px]" />
            </div>
          ),
          th: (props) => <th {...props} className="border border-white/10 bg-white/5 px-2 py-1 text-left" />,
          td: (props) => <td {...props} className="border border-white/10 px-2 py-1" />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
